<template>
  <context-menu style="transform: unset;" @ctx-close="onClose" :id="`${this.contextId}-newPage-context-menu`" :ref="`${this.contextId}-newPage-ctxMenu`" >
    <form class="p-2" style="width: 300px;" @submit.stop.prevent>
      <div class="mb-3">
        <label for="filterNameInput" class="form-label required">Nom de la page</label>
        <input required type="text" class="form-control required" id="filterNameInput" v-model="name">
      </div>
      <div class="w-100 text-center">
        <button @click="submit" class="btn btn-success btn-raised text-white">Valider</button>
      </div>
    </form>
  </context-menu>
</template>

<script>

import contextMenu from 'vue-context-menu';
import { mapGetters } from 'vuex';

export default {
  name: 'NewPageContext',
  components: {
    contextMenu,
  },
  props: {
    id: {
      required: false,
      type: String,
      default: 'unset',
    },
    pageName: {
      type: String,
      default: '',
      required: false,
    },
  },
  data()
  {
    return {
      contextId: '',
      name: '',
    };
  },
  created()
  {
    this.name = this.pageName;
    this.contextId = (this.id === 'unset') ? this.contextId = this.getNewId() : this.id;
  },
  computed: {
    ...mapGetters(['stringToSlug']),
  },
  methods: {
    submit()
    {
      this.name = this.stringToSlug(this.name, true);
      this.$emit('addPage', this.name);
      this.closeContext();
    },
    getNewId()
    {
      return this.$chance.string(this.$newIDParams);
    },
    onClose()
    {
      this.$refs[`${this.contextId}-newPage-ctxMenu`].ctxVisible = true;
    },
    openContext()
    {
      this.$refs[`${this.contextId}-newPage-ctxMenu`].open();
      this.name = this.pageName;
    },
    closeContext()
    {
      this.$refs[`${this.contextId}-newPage-ctxMenu`].ctxVisible = false;
    },
  },
};

</script>

<style scoped>

</style>
